import { render } from "./ProfileSettings.vue?vue&type=template&id=6e9c4228&scoped=true&ts=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=ts"
export * from "./ProfileSettings.vue?vue&type=script&lang=ts"

import "./ProfileSettings.vue?vue&type=style&index=0&id=6e9c4228&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9c4228"]])

export default __exports__